/* Diego Kong MX — Halloween Kong · vanilla JS, sin dependencias
   · Respaldo del apagado: si la fecha de fin ya pasó en el reloj del cliente (página en caché), se quita todo.
   · El banner del gorila sale después del popup de país (nunca encima), una vez por sesión.
   · Secuencia: destello + sacudida → gorila "¡BU!" salta → cambia al gorila feliz → tarjeta con el código. */
(function () {
  'use strict';
  var root = document.querySelector('[data-khw]');
  if (!root) return;

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SHOWN = 'khw_shown', APPLIED = 'khw_applied';
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- apagado por fecha (hora de México, UTC-6) ---------- */
  var end = root.getAttribute('data-end');
  if (end) {
    var endMs = Date.parse(end + 'T00:00:00-06:00');
    if (!isNaN(endMs) && Date.now() >= endMs && !(window.Shopify && window.Shopify.designMode)) {
      root.remove();
      document.querySelectorAll('.khw-strip, .khw-price, .khw-cart').forEach(function (n) { n.remove(); });
      return;
    }
  }
  document.documentElement.classList.add('khw-on');

  /* ---------- precio con código en la ficha de producto ---------- */
  var pct = 0;
  var priceLine = document.querySelector('[data-khw-price]');
  if (priceLine) {
    pct = parseFloat(priceLine.getAttribute('data-pct')) || 0;
    var nowEl = document.querySelector('[data-klf-now]');
    var out = priceLine.querySelector('[data-khw-price-value]');
    var fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 });
    var sync = function () {
      if (!nowEl || !out) return;
      var n = parseFloat(String(nowEl.textContent).replace(/[^0-9.]/g, ''));
      if (n > 0) out.textContent = fmt.format(Math.round(n * (100 - pct)) / 100);
    };
    if (nowEl && 'MutationObserver' in window) new MutationObserver(sync).observe(nowEl, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- banner del gorila ---------- */
  var dlg = root.querySelector('.khw-pop');
  var pill = root.querySelector('[data-khw-pill]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var code = root.getAttribute('data-code') || '';
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* Si llegó por /discount/CODIGO, Shopify ya lo aplicó: lo recordamos para la pastilla */
  if (/\/discount\//i.test(document.referrer || '') || /(^|[?&])discount=/i.test(location.search)) ls(APPLIED, '1');
  function markApplied() {
    if (ls(APPLIED) !== '1' || !pill) return;
    var sub = pill.querySelector('[data-khw-pill-sub]');
    if (sub) sub.textContent = '✓ APLICADO';
  }

  var imgsReady = null;
  function loadImgs() {
    if (imgsReady) return imgsReady;
    var list = Array.prototype.slice.call(dlg.querySelectorAll('[data-khw-src]'));
    imgsReady = Promise.all(list.map(function (img) {
      if (!img.src) img.src = root.getAttribute('data-img-' + img.getAttribute('data-khw-src'));
      return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    }));
    return imgsReady;
  }
  function whenReady(cb) {
    var done = false, go = function () { if (!done) { done = true; cb(); } };
    loadImgs().then(go); setTimeout(go, 2500);               /* nunca se queda esperando */
  }

  var timers = [];
  function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }

  function play(instant) {
    if (dlg.open) return;
    if (!imgsReady || !dlg._khwReady) { whenReady(function () { dlg._khwReady = true; play(instant); }); return; }
    if (blocker()) { waitForDialogs(function () { play(instant); }); return; }
    clearTimers();
    dlg.classList.remove('is-flash', 'is-shake', 'is-boo', 'is-happy', 'is-instant');
    dlg.showModal();
    var focusTarget = dlg.querySelector('.khw-pop__card');
    if (instant || REDUCE) {
      dlg.classList.add('is-instant', 'is-happy');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
      return;
    }
    void dlg.offsetWidth;
    dlg.classList.add('is-flash', 'is-shake', 'is-boo');
    if (navigator.vibrate) { try { navigator.vibrate([60, 40, 90]); } catch (e) {} }
    later(function () { dlg.classList.add('is-happy'); }, 1500);
    later(function () { if (focusTarget) focusTarget.focus({ preventScroll: true }); }, 1900);
  }

  function close() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () {
    clearTimers();
    if (!design) ss(SHOWN, '1');
    if (pill) { pill.hidden = false; requestAnimationFrame(function () { pill.classList.add('is-in'); }); }
  });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-khw-close]')) { close(); return; }
    var copyBtn = e.target.closest('[data-khw-copy]');
    if (copyBtn) copyCode(copyBtn);
    if (e.target.closest('[data-khw-apply]')) { ls(APPLIED, '1'); ss(SHOWN, '1'); }
  });

  function copyCode(btn) {
    var done = function () {
      btn.textContent = '¡Copiado!';
      btn.classList.add('is-done');
      setTimeout(function () { btn.textContent = 'Copiar'; btn.classList.remove('is-done'); }, 2200);
    };
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(done, function () { fallbackCopy(); done(); });
    } else { fallbackCopy(); done(); }
  }
  function fallbackCopy() {
    var t = document.createElement('textarea');
    t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
    dlg.appendChild(t); t.select();
    try { document.execCommand('copy'); } catch (e) {}
    t.remove();
  }

  if (pill) {
    pill.addEventListener('click', function () { play(true); });
    markApplied();
    /* en celular se esconde mientras el hero está a la vista (ahí no debe tapar precios ni botones) */
    var hero = document.querySelector('[data-hhs]');
    if (hero && 'IntersectionObserver' in window && window.matchMedia('(max-width: 749px)').matches) {
      new IntersectionObserver(function (en) { pill.classList.toggle('is-tucked', en[0].intersectionRatio > 0.15); }, { threshold: [0, 0.15, 0.5] }).observe(hero);
    }
  }

  /* Otros overlays abiertos: popup de país, buscador, carrito, popup de la página USA */
  function blocker() {
    var d = document.querySelector('dialog[open]:not(.khw-pop), .usa-popup-overlay.is-visible, cart-drawer.active, .drawer.active');
    return d;
  }
  function waitForDialogs(cb) {
    if (!blocker()) { cb(); return; }
    var iv = setInterval(function () {
      if (blocker()) return;
      clearInterval(iv);
      setTimeout(function () { if (blocker()) waitForDialogs(cb); else cb(); }, 900);
    }, 400);
  }

  /* ¿Va a salir el popup de país en esta visita? (misma regla que kf-homepage-popup) */
  function countryPopupPending() {
    var kp = document.querySelector('dialog.kp');
    if (!kp) return false;
    var p = location.pathname;
    if (p !== '/' && p !== '') return false;
    if (ls('kfx_market_pref')) return false;
    if (ss('kf_popup_dismissed')) return false;
    return true;
  }

  var wantsAuto = root.getAttribute('data-popup') === 'true' && (design ? false : !ss(SHOWN));
  if (!wantsAuto) {
    if (pill && (ss(SHOWN) || design)) { pill.hidden = false; requestAnimationFrame(function () { pill.classList.add('is-in'); }); }
    return;
  }

  var delay = parseInt(root.getAttribute('data-delay'), 10) || 3000;
  function schedule() {
    loadImgs();
    if (countryPopupPending()) {
      var kp = document.querySelector('dialog.kp');
      var hook = function () { kp.addEventListener('close', function () { setTimeout(function () { play(false); }, 1200); }, { once: true }); };
      if (kp.open) hook();
      else {
        /* espera a que el popup de país se abra (hasta 12 s); si nunca se abre, sigue el flujo normal */
        var waited = 0;
        var iv = setInterval(function () {
          waited += 250;
          if (kp.open) { clearInterval(iv); hook(); }
          else if (waited >= 12000) { clearInterval(iv); setTimeout(function () { play(false); }, delay); }
        }, 250);
      }
      return;
    }
    setTimeout(function () { play(false); }, delay);
  }
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
}());
